module.exports = __webpack_public_path__ + "static/media/Sponsors_bg.1ff0e454.webp";